export var ConnectorNames;
(function(ConnectorNames) {
    ConnectorNames["MetaMask"] = "metaMask";
    ConnectorNames["Injected"] = "injected";
    ConnectorNames["WalletConnect"] = "walletConnect";
    ConnectorNames["BSC"] = "bsc";
    ConnectorNames["Blocto"] = "blocto";
    ConnectorNames["WalletLink"] = "coinbaseWallet";
    ConnectorNames["Kaikas"] = "Kaikas";
    ConnectorNames["Ronin"] = "Ronin";
})(ConnectorNames || (ConnectorNames = {}));
